import { IBaseResponse } from "@nkr/models/base-response";
import { ICenterBase } from "@nkr/models/center-base";
import { AuthActionCreators } from "@nkr/store/authorization";
import { useAppHookContext } from "@nkr/utils/rest-api";
import { useEffect, useState } from "react";

interface IRetVal {
    list: ICenterBase[],
    loading: boolean,
    error: string
}

const useCenterListForOpo = (): IRetVal => {
    const { dispatch } = useAppHookContext();
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string>('');
    const [list, setList] = useState<ICenterBase[]>([]);

    useEffect(() => {
        setLoading(true);
        setError('');

        const fetchData = async () => {
            var config = {
                url: `${__API__}/strongbox/centers`,
            };

            try {
                const response: IBaseResponse = await dispatch(AuthActionCreators.apiGet(config));

                if (response && response.data.results && response.data.success) {
                    setList(response.data.results);
                } else {
                    setError('Unable to load data');
                    setList([]);
                }

            } catch (err) {
                setList([]);
                setError(err);
            } finally {
                setLoading(false);
            }
        }

        fetchData();
    }, []);

    return { loading, error, list }
}
export default useCenterListForOpo;